import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import './style.css';

const Calculator = () => {
  const [loanAmount, setLoanAmount] = useState(1.6413);
  const [tenure, setTenure] = useState(24);
  const [interestRate, setInterestRate] = useState(15.54);
  const [monthlyInstallment, setMonthlyInstallment] = useState(0);
  const [totalPayable, setTotalPayable] = useState(0);

  useEffect(() => {
    const rate = interestRate / 12 / 100;
    const emi =
      (loanAmount * 100000 * rate * Math.pow(1 + rate, tenure)) /
      (Math.pow(1 + rate, tenure) - 1);
    setMonthlyInstallment(emi.toFixed(2));
    setTotalPayable((emi * tenure).toFixed(2));
  }, [loanAmount, tenure, interestRate]);

  const handleLoanAmountChange = (event, newValue) => {
    setLoanAmount(newValue);
  };

  const handleTenureChange = (event, newValue) => {
    setTenure(newValue);
  };

  const handleInterestRateChange = (event, newValue) => {
    setInterestRate(newValue);
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-7">
          <div className="dc_calci_progress_main sm:tw-px-[12px]">
            <div className="sliderContainer">
              <Box sx={{ width: 535 }}>
                <div className="progress_headings">
                  <label className="tw-pointer-events-none tw-select-none">
                    Loan amount
                  </label>
                  <div className="loan_amunt">
                    ₹{(loanAmount * 100000).toLocaleString('en-IN')}
                  </div>
                </div>
                <Slider
                  defaultValue={loanAmount}
                  aria-label="Loan Amount"
                  valueLabelDisplay="auto"
                  min={1}
                  max={200}
                  step={1}
                  onChange={handleLoanAmountChange}
                  sx={{ color: '#1E4DDC' }}
                />
              </Box>
              <Box sx={{ width: 535 }}>
                <div className="progress_headings tw-pointer-events-none tw-select-none">
                  <label className="dark_label">Tenure</label>
                  <div className="loan_amunt">{tenure} Months</div>
                </div>

                <Slider
                  defaultValue={tenure}
                  aria-label="Tenure"
                  valueLabelDisplay="auto"
                  min={12}
                  max={360}
                  step={12}
                  onChange={handleTenureChange}
                  sx={{ color: '#1E4DDC' }}
                />
              </Box>
              <Box sx={{ width: 535 }}>
                <div className="progress_headings">
                  <label className="dark_label tw-pointer-events-none tw-select-none">
                    Interest rate{' '}
                  </label>
                  <div className="loan_amunt">{interestRate}%</div>
                </div>

                <Slider
                  defaultValue={interestRate}
                  aria-label="Interest Rate"
                  valueLabelDisplay="auto"
                  min={5}
                  max={25}
                  step={0.1}
                  onChange={handleInterestRateChange}
                  sx={{ color: '#1E4DDC' }}
                />
              </Box>
            </div>
          </div>
        </div>
        <div className="col-md-5">
          <div className="amtContainer">
            <div className="monthContainer">
              <div className="headingText tw-pointer-events-none tw-select-none">
                Monthly installment
              </div>
              <div className="amtText">
                ₹{parseInt(monthlyInstallment).toLocaleString('en-IN')}
              </div>
              <div className="subText tw-pointer-events-none tw-select-none">
                Inc. of all fee & taxes
              </div>
            </div>
            <div className="totContainer">
              <div className="headingText tw-pointer-events-none tw-select-none">
                Total payable
              </div>
              <div className="amtText amtText_light tw-text-[#000000]">
                ₹{parseInt(totalPayable).toLocaleString('en-IN')}
              </div>
              <div className="subText hide_desk tw-pointer-events-none tw-select-none">
                Inc. of fee &amp; taxes
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
